import { MissionManagerPayload } from "models/Mission";
import { AuthStore } from "store/Auth";
import serviceFetch from "services/helpers";
import MissionObject from "@a_team/models/dist/MissionObject";

export const updateMissionManagerSettings = async (
  auth: AuthStore,
  payload: MissionManagerPayload,
  missionId: string
): Promise<MissionObject> =>
  serviceFetch(
    auth,
    `missions/${missionId}/manager-settings`,
    null,
    "put",
    payload
  );

export const getMission = async (
  auth: AuthStore,
  missionId: string
): Promise<MissionObject> => {
  return serviceFetch(auth, `proxy/missions/${missionId}`, null, "get");
};
